export type QualityCheckpointId = 'brief' | 'bible' | 'devices' | 'episode' | 'scene' | 'sample' | 'draft';
export type CheckpointDecisionType = 'pass' | 'return' | 'abstain' | 'skip';

export interface QualityCheckpoint {
  id: QualityCheckpointId;
  label: string;
  question: string;
}

export const QUALITY_CHECKPOINTS: QualityCheckpoint[] = [
  { id: 'brief', label: '01 创作简报', question: '这个前提能否启动持续而具体的行动？' },
  { id: 'bible', label: '02 人物与故事圣经', question: '人物是否会主动制造因果，而不只是被剧情推动？' },
  { id: 'devices', label: '03 戏剧装置账本', question: '装置是否改变故事，并有前提与兑现？' },
  { id: 'episode', label: '04 单集合同', question: '本集是否升级、改变状态并产生明确追看欲？' },
  { id: 'scene', label: '05 场景合同', question: '每场是否有目标、阻力、策略变化和退出状态？' },
  { id: 'sample', label: '06 关键场试写', question: '行动、对白、潜台词和影像是否共同工作？' },
  { id: 'draft', label: '07 完整成稿', question: '承诺是否兑现，并留下独特声音和情感余味？' },
];

const RUBRICS: Record<QualityCheckpointId, string[]> = {
  brief: ['premise', 'desire', 'opposition', 'stakes', 'novelty', 'format_fit'],
  bible: ['agency', 'contradiction', 'relationship_pressure', 'arc', 'voice_spec'],
  devices: ['prerequisite', 'causal_function', 'setup_payoff', 'repetition'],
  episode: ['entry_disturbance', 'escalation', 'state_change', 'hook', 'duration'],
  scene: ['necessity', 'objective', 'opposition', 'character_action', 'turn', 'state_delta', 'dialogue', 'visual_action', 'producibility'],
  sample: ['readability', 'character_action', 'dialogue', 'subtext', 'pacing', 'visual_action', 'voice'],
  draft: ['story', 'causality', 'character', 'payoff', 'voice', 'emotion', 'originality', 'producibility'],
};

export function checkpointRubric(id: QualityCheckpointId): string[] {
  return [...RUBRICS[id]];
}

export function qualityArtifactPath(artifactId: string): string {
  return `/api/generation-artifacts/${encodeURIComponent(artifactId.trim())}`;
}

export function createCheckpointDecision(
  checkpointId: QualityCheckpointId,
  decision: CheckpointDecisionType,
  artifactId: string,
  evidenceAddresses: string[],
  note: string,
) {
  return {
    checkpointId,
    decision,
    artifactId,
    evidenceAddresses,
    note: note.trim(),
    recordedAt: new Date().toISOString(),
    schemaVersion: '1.0',
  };
}
